// extracted by mini-css-extract-plugin
export default {"textAdd":"SectionLocationCoachingCulture_textAdd__mFstg","aspectW":"SectionLocationCoachingCulture_aspectW__w4eZn","lineTexts":"SectionLocationCoachingCulture_lineTexts__oeW6l"};